import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { CreditGridDataService } from 'common/services/data-services/admin/credit/credit-grid-data.service';
import { CreditModel } from 'common/models/page-models/credits/credit-data-model';
import { CreditGridMetaModel } from 'common/models/page-models/credits/credit-grid-meta-model';
import { CreditListingModel } from 'common/models/page-models/credits/credit-grid-model';


 
@Injectable({
    providedIn: 'root'
})
export class CreditGridWidgetService extends GridWidgetService<CreditModel, CreditListingModel> {
    constructor(protected override ds: CreditGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new CreditGridMetaModel().getMetaModel();
        return meta;
    }
}